import { Icon } from '@iqueue/ui-kit'
import cn from 'classnames'
import GoToHome from './GoToHome'

export default function NotFoundError ({ className, refetch }) {
  return <div className={ cn('iq-error-view center', className) }>
    <h1><Icon>follow_the_signs</Icon></h1>
    <h3>Запрашиваемый ресурс не найден</h3>
    { !!refetch && <GoToHome /> }
  </div>
}
